import React from "react";
import { Form, Input } from "antd";

const BusinessName = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="bussinessName"
      label="Business Name"
      rules={[
        {
          required: true,
          message: "Please input bussiness name",
        },
      ]}
    >
      <Input showCount maxLength={30} placeholder="Business Name" disabled={disabled} />
    </Form.Item>
  );
};

export default BusinessName;
